module.exports = __webpack_public_path__ + "static/img/CT_1.8788b40c.png";